<template>
    <div class="flex justify-end space-x-1">
        <InertiaSquareLinkButton action="show" :href="itinerary.links.show" />
        <InertiaSquareLinkButton action="edit" :href="itinerary.links.edit" />
        <InertiaSquareDeleteButton :href="itinerary.links.delete" v-if="itinerary.links.delete" />
        <OptionsPanel>
            <InertiaSquareLinkButton
                action="duplicate"
                :href="itinerary.links.duplicate"
                v-if="itinerary.links.duplicate"
                method="post"
                as="button"
            />
        </OptionsPanel>
    </div>
</template>
<script>
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import OptionsPanel from '@/components/OptionsPanel.vue';

export default {
    name: 'ItineraryActionButtons',
    components: { InertiaSquareDeleteButton, InertiaSquareLinkButton, OptionsPanel },
    props: {
        itinerary: {},
    },
};
</script>
